import { useEffect, useState } from 'react';
import { request, gql } from "graphql-request"
import moment from 'moment'
import { ethers } from 'ethers'
import BigNumber from 'bignumber.js'

const WARDEN_FARM_SUBGRAPH_URL = process.env.REACT_APP_WARDEN_FARM_SUBGRAPH_URL
const PANCAKE_FARM_SUBGRAPH_URL = process.env.REACT_APP_PANCAKE_FARM_SUBGRAPH_URL

export interface ApiStatResponse {
	[address: string]: {
		dailyVolumeUSD: number,
		reserveUSD: number,
		feeYearly: number
	}
}

export const useFarmDayTradeVolumeAndFeeEarn = () => {
	const [data, setData] = useState<ApiStatResponse | null>(null);

	useEffect(() => {
		const fetchData = async () => {
			const oneDayAgo = moment.utc().subtract(1, 'days').startOf('day').unix()

			try {
				const [wardenFarm] = await Promise.all([
					request(
						WARDEN_FARM_SUBGRAPH_URL,
						gql`{
								pairDayDatas(where:{ date: ${oneDayAgo} }) {
								date
								pairAddress
								dailyVolumeUSD
								reserveUSD
							}
						}`,
					)
				]);
				// request(
				// 	PANCAKE_FARM_SUBGRAPH_URL,
				// 	gql`
				// 		{
				// 			pairDayDatas(
				// 				where: {
				// 					pairAddress_in: [
				// 						"0xf70a40749006c7952186666c92f32b8f5c2129f9"
				// 						"0x7d6195b212dee1ba7de8404cfd319446cf17d71b"
				// 					]
				// 					date: ${oneDayAgo}
				// 				}
				// 			) {
				// 				date
				// 				dailyVolumeUSD
				// 				reserveUSD
				// 				pairAddress {
				// 					id
				// 				}
				// 			}
				// 		}
				// 	`,
				// ),
				const wardenFarmPairsDayDatas = wardenFarm.pairDayDatas
				// const pancakeFarmPairsDayDatas = pancakeFarm.pairDayDatas.map((val) => {
				// 	const newData = { ...val, pairAddress: val.pairAddress.id }

				// 	return newData;
				// })

				const groupOfFarm = [...wardenFarmPairsDayDatas]
				const farmObj = {}
				groupOfFarm.forEach(farm => {
					const lpFeesfeeInOneDay = new BigNumber(farm.dailyVolumeUSD).times(0.0017)
					const feeYearly = new BigNumber(lpFeesfeeInOneDay).div(farm.reserveUSD).times(100).times(365).toString()
					farmObj[ethers.utils.getAddress(farm.pairAddress)] = {
						dailyVolumeUSD: Number(farm.dailyVolumeUSD),
						reserveUSD: Number(farm.reserveUSD),
						feeYearly: new BigNumber(feeYearly).isNaN() ? 0 : feeYearly,
					};
				})
				setData(farmObj)
			} catch (error) {
				// @ts-ignore
				console.error('Unable to fetch data:', error);
			}
		};

		fetchData();
	}, []);

	return data;
}